import Conversation from "../../Pages/Conversation/Conversation";
import ErrorPage from "../../Pages/Error/Error";
import { Feedback } from "../../Pages/Feedback/Feedback";
import Intro from "../../Pages/Intro/Intro";
import { LoadingConversation } from "../../Pages/LoadingConversation/LoadingConversation";
import PreConvTest from "../../Pages/PerConvTest/PreConvTest";
import PrivacyPolicy from "../../Pages/PrivacyPolicy/PrivacyPolicy";
import Questions from "../../Pages/Question/Questions";

const pages = [
  "Intro",
  "Policy",
  "Questions",
  "HardwareTest",
  "LoadingConversation",
  "Conversation",
  "Feedback",
  "Error",
] as const;
type PageItem = { default: string; routes: string[]; element: any };
export type KnownPages = typeof pages[number];
const routesMap: { [key in KnownPages]: PageItem } = {
  Intro: {
    default: "/",
    routes: [
      "/",
      "/Intro",
      "/main",
      "/index",
      "/vip/",
      "/vip/Intro",
      "/vip/main",
      "/vip/index",
    ],
    element: <Intro />,
  },
  Policy: {
    default: "/policy",
    routes: ["/policy", "/vip/policy"],
    element: <PrivacyPolicy />,
  },
  Questions: {
    default: "/question",
    routes: [
      "/question",
      "/questionnaire",
      "/vip/question",
      "/vip/questionnaire",
    ],
    element: <Questions />,
  },
  HardwareTest: {
    default: "/pre-flight",
    routes: ["/pre-flight", "/vip/pre-flight"],
    element: <PreConvTest />,
  },
  LoadingConversation: {
    default: "/loading",
    routes: ["/loading", "/vip/loading"],
    element: <LoadingConversation />,
  },
  Conversation: {
    default: "/video-chat",
    routes: ["/video-chat", "/vip/video-chat"],
    element: <Conversation />,
  },
  Feedback: {
    default: "/feedback",
    routes: ["/feedback", "/vip/feedback"],
    element: <Feedback />,
  },
  Error: {
    default: "/error",
    routes: ["/error", "/vip/error"],
    element: <ErrorPage />,
  },
};

export default routesMap;
